import { createFileRoute } from '@tanstack/react-router'
import ForgotPasswordScreen from './-components'

export const Route = createFileRoute('/(auth)/forgot-password/')({
  component: () => <ForgotPasswordScreen />
}) 